import { render } from "./UserPostListPage.vue?vue&type=template&id=eec0c3e0"
import script from "./UserPostListPage.vue?vue&type=script&lang=ts"
export * from "./UserPostListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script